<script setup lang="ts">
import { Ref, reactive, ref } from 'vue';
import {
  showLoginDialog,
  loginCodeUrl,
  validCode,
  verifyTime,
  closeLoginDialog,
  // stopLoginPoll,
  getLoginCode,
  getVerifyCode,
  phoneLogin
} from './login';
import { isMobile } from '@/data/pubilc';
// import Tips from "./tips.vue";

const loginWay = reactive([
  {
    name: '扫码登录',
    type: 0,
    isShow: true
  },
  {
    name: '手机号登录',
    type: 1,
    isShow: true
  }
]);
const loginWayType: Ref<number> = ref(0);

// watch(
//   isMobile,
//   (val) => {
//     if (val) {
//       loginWayType.value = 1;
//       loginWay.length = 1;
//       loginWay[0] = { name: "手机号登录", type: 1, isShow: true };
//     }
//   },
//   { immediate: true }
// );

const form = reactive({
  phoneNumber: '',
  code: ''
});

// watch(loginWayType, (val) => {
//   if (val == 1) {
//     stopLoginPoll();
//   } else {
//     getLoginCode();
//   }
// });
</script>

<template>
  <CsdDialog :showDialog="showLoginDialog">
    <div class="login-dialog" :class="{ '!px-20 !h-380': isMobile }" rounded-20>
      <CsdClose @click="closeLoginDialog" />
      <!-- <CsdImg :src="`/images/login-left-image.svg`" class="w-350" /> -->
      <div py-50 px-80 bg="#F2F3FF" rounded-20>
        <div flex-center px-20 pb-30 v-if="false">
          <div
            v-for="(item, index) in loginWay.filter(item => item.isShow)"
            :key="index"
            class="login-way flex-center"
            :class="[{ 'checked-way': loginWayType == item.type }, { '!w-100': isMobile }]"
            @click="loginWayType = item.type"
          >
            {{ item.name }}
          </div>
        </div>
        <div v-if="loginWayType == 0" class="code-login">
          <div flex-center text-20 text="#333333" font-700>
            <!-- <CsdImg
              :src="`/images/weixin.svg`"
              class="size-32 rounded-full mr-8"
            /> -->
            微信扫码登录或注册
          </div>
          <!-- <div flex-center my-15 text-13>
            <div class="left-line"></div>
            <div px-2>扫码登录 快速下载</div>
            <div class="right-line"></div>
          </div> -->
          <div mt-30 mb-20 mx-auto bg-white size-230 p-10>
            <!-- solid-border border-1 border="#EFEFEF" -->
            <div full bg-white rounded-3 relative truncate>
              <!-- <Tips /> -->
              <CsdImg :src="loginCodeUrl" class="size-210" />
              <!-- <div absolute full flex-center z-4 t-0>
                <CsdImg
                  :src="`/images/square.png`"
                  class="size-60 rounded-8 border-6 solid-border border-white"
                  v-if="loginCodeUrl"
                />
              </div> -->
              <div
                v-if="!validCode"
                full
                absolute
                l-0
                t-0
                flex-align
                justify-center
                z-5
                bg="#00000095"
                text-white
                cursor-pointer
                hover:text-15
                hover:font-bold
                @click="getLoginCode"
              >
                二维码已过期，点击刷新
              </div>
            </div>
          </div>
          <div flex-center text="#373839" text-13>扫码关注“AI智能PPT助手”即可登录注册</div>
          <div flex-center mt-8 text="#373839" text-13>首次扫码将自动注册新账号</div>
          <div text="#999999" flex-center mt-30 text-12>注册登录即代表同意 《用户协议》</div>
        </div>
        <div v-else class="phone-login" :class="!isMobile ? 'w-342' : 'w-250'">
          <div h-52 solid-border border-2 rounded-8 px-12 flex mb-25>
            <el-input v-model="form.phoneNumber" class="!h-48" placeholder="请输入手机号" />
            <div h-full flex-center ml-10 text="#5865F2">
              <span
                cursor-pointer
                whitespace-nowrap
                hover:text="#5865F2cc"
                active:text="#5865F2"
                @click="getVerifyCode(form.phoneNumber)"
              >
                {{ verifyTime > 0 ? `重新获取(${verifyTime}s)` : '发送验证码' }}
              </span>
            </div>
          </div>
          <div h-52 solid-border border-2 rounded-8 px-12 flex mb-50>
            <el-input v-model="form.code" class="!h-48" placeholder="请输入验证码" />
          </div>
          <div class="primary-button h-52 rounded-8 text-16" @click="phoneLogin(form)">登录</div>
        </div>
      </div>
    </div>
  </CsdDialog>
</template>

<style lang="scss">
.login-dialog {
  position: relative;
  border-radius: 6px;
  display: flex;

  .login-way {
    width: 150px;
    padding-bottom: 6px;
    text-align: center;
    font-size: 16px;
    // color: #b4b9bf;
    // border-bottom: 2px solid #36373d;
    cursor: pointer;
  }

  .code-login {
    .left-line {
      width: 65px;
      height: 2px;
      background: linear-gradient(244deg, #dddddd 50%, #dddddd00 100%);
      transform: translateY(1px);
    }

    .right-line {
      width: 65px;
      height: 2px;
      background: linear-gradient(244deg, #dddddd00 0%, #dddddd 50% 50%);
      transform: translateY(1px);
    }
  }

  .checked-way {
    color: #5865f2;
    border-bottom: 2px solid #5865f2;
  }

  .phone-login {
    .el-input__wrapper {
      background-color: transparent;
      box-shadow: none;
      padding-left: 0;
      padding-right: 0;
    }
  }
}
</style>
